export default {
    NONE: "NONE",
    DRAFT: "DRAFT",
    COMPLETED: "COMPLETED",
    SEND: "SEND",
    PUBLISHED: "PUBLISHED",
    PUBLICATION_ERROR: "PUBLICATION_ERROR",
    INTEGRATION_ERROR: "INTEGRATION_ERROR"
}